<script setup lang="ts">
import { isStagingEnv } from '@/config/runtimeEnv'
</script>

<template>
  <div
    v-if="isStagingEnv()"
    class="sticky top-0 z-50 bg-amber-500 px-4 py-1.5 text-center text-xs font-semibold tracking-wide text-amber-950"
  >
    STAGING — connected to the staging environment
  </div>
</template>
